import React, { useEffect, useState } from 'react';
import { Modal } from '@material-ui/core';
import './MasterEggHunterModal.scss';
import EggHunterBadge from 'assets/images/badges/egg-hunter-badge.svg';
import Confetti from 'react-confetti';
import debounce from 'lodash.debounce';

interface WelcomeModalProps {
	open: boolean;
	allowClickOutsideToClose?: boolean;
	onCloseClicked: () => void;
}

const MasterEggHunterModal: React.FC<WelcomeModalProps> = (props: WelcomeModalProps) => {
	const { open, allowClickOutsideToClose, onCloseClicked } = props;
	const [dropConfetti, setDropConfetti] = useState(false);
	const [confettiHeight, setConfettiHeight] = useState(0);
	const [confettiWidth, setConfettiWidth] = useState(0);
	const confettiColors: string[] = ['#F7E582', '#EA33C0', '#9D1DED', '#641EA7', '#F2A199', '#EC57B3', 'FFFFFF'];

	const modalWrapperProps = {
		open: open,
		...(allowClickOutsideToClose && { onClose: onCloseClicked }),
	};

	useEffect(() => {
		if (open) {
			const debouncedHandleResize = debounce(() => {
				setConfettiHeight(window.innerHeight);
				setConfettiWidth(window.innerWidth);
			}, 300);

			let confettiTimeout = setTimeout(() => {
				setConfettiHeight(window.innerHeight);
				setConfettiWidth(window.innerWidth);
				window.addEventListener('resize', debouncedHandleResize);
				setDropConfetti(true);
			}, 2000);

			return () => {
				window.removeEventListener('resize', debouncedHandleResize);
				clearTimeout(confettiTimeout);
			};
		}
	}, [open]);

	return (
		<Modal {...modalWrapperProps} className={'master-egg-hunter__modal-wrapper'} onClick={onCloseClicked}>
			<div className={`hunter-badge-wrapper ${open ? 'hunter-badge-wrapper--active' : ''}`}>
				<Confetti
					height={confettiHeight}
					width={confettiWidth}
					gravity={0.05}
					numberOfPieces={dropConfetti ? 400 : 0}
					recycle={true}
					colors={confettiColors}
					onConfettiComplete={confetti => {
						setDropConfetti(false);
						confetti?.reset();
					}}
				/>
				<div className='badge-shadow'></div>
				<img src={EggHunterBadge} alt='' className='badge-icon'></img>
				<div className='hunter-badge-wrapper__title'>You are a Master Egg Hunter!</div>
			</div>
		</Modal>
	);
};

export default MasterEggHunterModal;
